import PropTypes from "prop-types";

export const deliveryOptionProp = PropTypes.shape({
    codeCode: PropTypes.string,
    codeType: PropTypes.string,
    codeDescription: PropTypes.string
});
